// Single source of truth for HomeIQ + Vastu brand assets.
// • HOMEIQ_LOGO        — primary HomeIQ wordmark (used in navbar / footer / shell header).
// • VASTU_BY_HOMEIQ    — co-branded lockup. Used on the HOMEPAGE wherever the Vastu
//                        feature is referenced (navbar, footer, marketing surfaces).
// • VASTU              — standalone Vastu wordmark. Used INSIDE the Vastu experience
//                        (Vastu tab header, upload / manual / confirmation / results
//                        screens). Never co-branded inside the workflow.

export const HOMEIQ_LOGO =
    "https://customer-assets.emergentagent.com/job_collapse-hero/artifacts/on4rcrcg_HomeIQ_transparent.png";

export const VASTU_BY_HOMEIQ_LOGO =
    "https://customer-assets.emergentagent.com/job_collapse-hero/artifacts/69ltosfu_Vastu_By_HomeIQ_Transparent.png";

export const VASTU_LOGO =
    "https://customer-assets.emergentagent.com/job_collapse-hero/artifacts/cbn1k4jd_Vastu_Transparent.png";
